import React from 'react';
import { StyleSheet } from 'react-native';
import { Typography, Box } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { ColorScheme, theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { isEmpty } from '../../utils/lodash';
import FilmIcon from '../CustomSVGIcons/FilmIcon';

interface ITags {
    tags?: string[];
    typographyStyle?: React.CSSProperties;
    iconStyle?: React.CSSProperties;
    dotStyle?: React.CSSProperties;
    iconFill?: string;
    maxTag: number;
}

const TagsRenderer: React.FC<ITags> = ({ tags, typographyStyle, iconFill, maxTag, dotStyle }) => {
    const { themeStyle } = useThemeContext();
    const styles = dynamicStyles(themeStyle);

    return (
        <Box style={styles.flexRow} sx={{ gap: '4px', width: 'fit-content' }}>
            <FilmIcon fill={theme[themeStyle].true_white} width="20px" height="20px" />
            {tags &&
                !isEmpty(tags) &&
                tags.slice(0, maxTag).map((tag, index) => (
                    <Box sx={{ display: 'flex', alignItems: 'center' }} key={index}>
                        <Typography
                            style={{ ...styles.textSm, ...typographyStyle }}
                            sx={{ color: theme[themeStyle].true_white }}>
                            {tag}{' '}
                        </Typography>
                        {index !== tags.length - 1 && (
                            <hr
                                style={{
                                    width: '4px',
                                    height: '4px',
                                    borderRadius: 100,
                                    marginRight: '4px',
                                    marginLeft: '4px',
                                    backgroundColor: theme[themeStyle].tertiary_dark,
                                    ...dotStyle,
                                }}
                            />
                        )}
                    </Box>
                ))}
            {tags && !isEmpty(tags) && tags.length > maxTag && (
                <Typography style={{ ...styles.more }} sx={{ color: theme[themeStyle].true_white, ...typographyStyle }}>
                    + {tags.length - maxTag} more
                </Typography>
            )}
        </Box>
    );
};

const dynamicStyles = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        textSm: {
            fontSize: 12,
            fontWeight: '500',
            fontFamily: FONT_ENUM.MAIN_REGULAR,
            textTransform: 'capitalize',
        },
        more: {
            fontSize: 12,
            fontWeight: '500',
            fontFamily: FONT_ENUM.MAIN_REGULAR,
            color: theme[colorScheme].true_white,
        },
        flexRow: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
        },
    });

export { TagsRenderer };
